/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["az",[["a","p"],["AM","PM"]],[["AM","PM"]],[["7","1","2","3","4","5","6"],["B.","B.e.","Ã.a.","Ã.","C.a.","C.","Å."],["bazar","bazar ertÉsi","Ã§ÉrÅÉnbÉ axÅamÄ±","Ã§ÉrÅÉnbÉ","cÃ¼mÉ axÅamÄ±","cÃ¼mÉ","ÅÉnbÉ"],["B.","B.E.","Ã.A.","Ã.","C.A.","C.","Å."]],[["7","1","2","3","4","5","6"],["B.","B.E.","Ã.A.","Ã.","C.A.","C.","Å."],["bazar","bazar ertÉsi","Ã§ÉrÅÉnbÉ axÅamÄ±","Ã§ÉrÅÉnbÉ","cÃ¼mÉ axÅamÄ±","cÃ¼mÉ","ÅÉnbÉ"],["B.","B.E.","Ã.A.","Ã.","C.A.","C.","Å."]],[["1","2","3","4","5","6","7","8","9","10","11","12"],["yan","fev","mar","apr","may","iyn","iyl","avq","sen","okt","noy","dek"],["yanvar","fevral","mart","aprel","may","iyun","iyul","avqust","sentyabr","oktyabr","noyabr","dekabr"]],u,[["e.É.","y.e."],u,["eramÄ±zdan ÉvvÉl","yeni era"]],1,[6,0],["dd.MM.yy","d MMM y","d MMMM y","d MMMM y, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[",",".",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0%","#,##0.00Â Â¤","#E0"],"AZN","â¼","AzÉrbaycan ManatÄ±",{"AZN":["â¼"],"BYN":[u,"Ñ."],"JPY":["JPÂ¥","Â¥"],"PHP":[u,"â±"],"RON":[u,"ley"],"SYP":[u,"SÂ£"],"THB":["à¸¿"],"TWD":["NT$"],"USD":["US$","$"]},"ltr", plural];
